export const eventsLocations = {
  webinar: 'Web conference',
  onsight: 'Onsight',
};
